export default "__VITE_ASSET__DxLEmLWD__"